import { useEffect, useState } from 'react';
import { authService } from '../services/auth/auth.service';

// GUIDs can be returned in different case and with either '-' or '_' separators,
// so normalize both sides before comparing.
const normalizeGUID = (guid: string): string => guid.toLowerCase().replace(/_/g, '-');

export const useVisibilityGUID = (guids: string[]) => {
  const [state, setState] = useState<boolean>(false);
  useEffect(() => {
    const subCustomerGuid = authService.sub.customerGUID().subscribe({
      next: (guid) => {
        const specialCustomers: string[] = guids.map(normalizeGUID);
        setState(specialCustomers.includes(normalizeGUID(guid)));
      },
      // The session read can fail (offline, Cognito unreachable). Without this
      // handler RxJS treats it as an unhandled stream error and reports it to
      // Sentry (WA-3800) — for a hook whose only job is to hide an optional,
      // company-specific control. No GUID means "not one of those companies".
      error: () => setState(false),
    });
    return () => {
      subCustomerGuid.unsubscribe();
    };
  }, []);
  return state;
};
